(function () {
  var HOST_SELECTOR = '[id^="reconvert-slot-cartDrawer"]';
  var ANCHOR_SELECTOR = '#CartDrawer .cart-drawer-reconvert-anchor';
  var STYLE_ID = 'calista-rc-drawer-css';
  var TRACK_CLASS = 'calista-rc-track';
  var INNER_CLASS = 'calista-rc-track-inner';
  var CSS =
    '#' +
    STYLE_ID +
    '-mark{display:none}' +
    '#slot-nonEmpty-5-content,#cartDrawer-slot-5,.section_content{padding:0.3rem 0 0.4rem !important;background:transparent !important;}' +
    '.widget_divider_line{display:none !important;}' +
    '.custom-space,.mt-4.break-words.custom-space{margin:0.4rem 0 0.8rem !important;}' +
    '.heading_font h2{font-family:var(--font-heading-family) !important;font-style:var(--font-heading-style) !important;font-weight:400 !important;font-size:20px !important;letter-spacing:0 !important;line-height:1.3 !important;margin:0 !important;color:#111 !important;text-transform:none !important;}' +
    '.' +
    TRACK_CLASS +
    '{position:relative;overflow:hidden;width:100%;padding:0 0 0.6rem;margin:0;cursor:grab;touch-action:pan-y pinch-zoom;-webkit-user-select:none;user-select:none;}' +
    '.' +
    TRACK_CLASS +
    '.is-dragging{cursor:grabbing;}' +
    '.' +
    INNER_CLASS +
    '{display:flex;gap:0.8rem;will-change:transform;transition:transform 0.45s cubic-bezier(0.22,1,0.36,1);}' +
    '.' +
    TRACK_CLASS +
    '.is-dragging .' +
    INNER_CLASS +
    '{transition:none;}' +
    '.' +
    INNER_CLASS +
    ' > div{flex:0 0 88%;width:88%;max-width:88% !important;min-width:0 !important;margin:0 !important;padding:0.8rem !important;gap:0.8rem !important;display:flex !important;flex-direction:column !important;border:1px solid #e6e6e6 !important;border-radius:0 !important;background:#fff !important;box-sizing:border-box;}' +
    '.space-y-3{margin:0 !important;padding:0 !important;background:transparent !important;}' +
    '.space-y-3 > :not([hidden]) ~ :not([hidden]){margin:0 !important;}' +
    '.product-image,.product-image *{border-radius:0 !important;border:0 !important;}' +
    '.product-image{object-fit:cover !important;width:100% !important;height:100% !important;}' +
    '[style*="min-width: 64px"],[style*="min-width:64px"]{min-width:5.6rem !important;max-width:5.6rem !important;max-height:5.6rem !important;}' +
    '.border.border-solid.border-gray-300{border:0 !important;border-radius:0 !important;overflow:hidden;}' +
    '.product_title_style{font-family:var(--font-heading-family) !important;font-size:16px !important;font-weight:400 !important;line-height:1.3 !important;color:#28181C !important;margin:0 0 0.2rem !important;}' +
    '.product_details_style,.product_details_style span{font-size:14px !important;font-weight:400 !important;line-height:1.35 !important;color:#000 !important;text-transform:none !important;letter-spacing:0 !important;}' +
    '.deleted_price{color:#A6A6A6 !important;font-size:14px !important;font-weight:400 !important;text-decoration:line-through !important;}' +
    '.normal_price{color:#000 !important;font-size:16px !important;font-weight:500 !important;}' +
    '.flex.justify-between.gap-2.w-full:has(.theme_button),.flex.justify-between.gap-2.w-full:has(#checkout_btn){justify-content:flex-end !important;width:100% !important;margin:0 !important;}' +
    '.btn_container,.btn_container.w-full,.btn_container .w-full{width:auto !important;max-width:none !important;justify-content:flex-end !important;}' +
    '.theme_button,.theme_button.theme_button_secondary,#checkout_btn{width:auto !important;max-width:none !important;min-width:auto !important;min-height:auto !important;height:auto !important;padding: 0.4rem 1rem 0.6rem !important;margin:0 !important;border:1px solid #000 !important;border-radius:0 !important;background:#fff !important;color:#000 !important;box-shadow:none !important;transform:none !important;overflow:visible !important;letter-spacing:normal !important;}' +
    '.theme_button:hover,.theme_button.theme_button_secondary:hover,#checkout_btn:hover{transform:none !important;box-shadow:none !important;background:#fff !important;}' +
    '.theme_button::before,.theme_button::after{display:none !important;content:none !important;}' +
    '.theme_button .span_style{position:static !important;z-index:1;}' +
    '.theme_button .span_style > span{font-size:0 !important;letter-spacing:0 !important;line-height:0 !important;}' +
    ".theme_button .span_style > span::after{content:'ADD +';font-size:1.2rem;font-weight:600;letter-spacing:0.04em;line-height:1;color:#111;white-space:nowrap;}" +
    '@media screen and (max-width:749px){' +
    '.heading_font h2{font-size:16px !important;}' +
    '.section_content .heading_font{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:14px !important;}' +
    '.product_details_style,.product_details_style span{font-size:12px !important;}' +
    '.' +
    INNER_CLASS +
    ' > div{flex-basis:86%;width:86%;max-width:86% !important;}' +
    '.theme_button,.theme_button.theme_button_secondary,#checkout_btn{width:auto !important;max-width:none !important;min-width:auto !important;min-height:auto !important;height:auto !important;padding:0.3rem 1rem 0.3rem !important;margin:0 !important;border:1px solid #000 !important;border-radius:0 !important;background:#fff !important;color:#000 !important;box-shadow:none !important;transform:none !important;overflow:visible !important;letter-spacing:normal !important;}' +
    '.theme_button .span_style{height:fit-content;}' +
    '.theme_button .span_style span{height:100%;display:block;}' +
    '.deleted_price{font-size:12px !important;}' +
    '.normal_price{font-size:14px !important;}' +
    '}';

  function isProductCard(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.classList.contains(TRACK_CLASS)) return false;
    if (el.classList.contains(INNER_CLASS)) return false;
    if (el.classList.contains('widget_divider_line')) return false;
    if (el.querySelector('.theme_button, .btn_container, .product-image, .product_title_style')) return true;
    return false;
  }

  function repositionHost(host) {
    var anchor = document.querySelector(ANCHOR_SELECTOR);
    if (!anchor || !host) return;
    if (host.parentElement !== anchor) {
      anchor.appendChild(host);
    }
  }

  function injectStyle(shadow) {
    if (shadow.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    shadow.appendChild(style);
  }

  function getInner(track) {
    return track.querySelector(':scope > .' + INNER_CLASS);
  }

  function slideStep(track) {
    var inner = getInner(track);
    if (!inner) return track.clientWidth;
    var card = inner.firstElementChild;
    if (!card) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(inner).columnGap || getComputedStyle(inner).gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function maxOffset(track) {
    var inner = getInner(track);
    if (!inner) return 0;
    return Math.max(0, inner.scrollWidth - track.clientWidth);
  }

  function clampOffset(track, value) {
    return Math.min(maxOffset(track), Math.max(0, value));
  }

  function displayedOffset(track) {
    var inner = getInner(track);
    if (!inner) return 0;
    var transform = getComputedStyle(inner).transform;
    if (!transform || transform === 'none') return track._calistaRcOffset || 0;
    var values = transform.replace(/^matrix3d\(|^matrix\(|\)$/g, '').split(',');
    var x = transform.indexOf('matrix3d') === 0 ? values[12] : values[4];
    return Math.abs(parseFloat(x) || 0);
  }

  function setOffset(track, value, animate) {
    var inner = getInner(track);
    if (!inner) return;
    var offset = clampOffset(track, value);
    track._calistaRcOffset = offset;
    inner.style.transition = animate ? 'transform 0.45s cubic-bezier(0.22, 1, 0.36, 1)' : 'none';
    inner.style.transform = 'translate3d(' + -offset + 'px, 0, 0)';
  }

  function currentIndex(track) {
    var step = slideStep(track);
    if (step <= 0) return 0;
    return Math.round(displayedOffset(track) / step);
  }

  function maxIndex(track) {
    var step = slideStep(track);
    if (step <= 0) return 0;
    return Math.round(maxOffset(track) / step);
  }

  function goTo(track, index) {
    var i = Math.min(maxIndex(track), Math.max(0, index));
    setOffset(track, i * slideStep(track), true);
  }

  function bindSlider(track) {
    if (track.dataset.calistaRcBound === 'true') return;
    track.dataset.calistaRcBound = 'true';

    var state = {
      dragging: false,
      startX: 0,
      startOffset: 0,
      lastX: 0,
      lastTime: 0,
      velocity: 0,
      moved: false,
      wheelLock: false,
      pointerId: null
    };

    track._calistaRcOffset = 0;
    setOffset(track, 0, false);

    function onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target.closest('button, a, input, select, textarea, label')) return;
      if (maxOffset(track) <= 0) return;

      state.dragging = true;
      state.moved = false;
      state.pointerId = event.pointerId;
      state.startX = event.clientX;
      state.lastX = event.clientX;
      state.lastTime = Date.now();
      state.startOffset = displayedOffset(track);
      state.velocity = 0;
      track._calistaRcOffset = state.startOffset;
      track.classList.add('is-dragging');

      try {
        track.setPointerCapture(event.pointerId);
      } catch (err) {}

      track.addEventListener('pointermove', onPointerMove);
      track.addEventListener('pointerup', onPointerUp);
      track.addEventListener('pointercancel', onPointerUp);
    }

    function onPointerMove(event) {
      if (!state.dragging || event.pointerId !== state.pointerId) return;
      var now = Date.now();
      var dx = event.clientX - state.lastX;
      var dt = Math.max(now - state.lastTime, 1);
      state.velocity = dx / dt;
      state.lastX = event.clientX;
      state.lastTime = now;

      if (Math.abs(event.clientX - state.startX) > 4) state.moved = true;
      setOffset(track, state.startOffset - (event.clientX - state.startX), false);
    }

    function onPointerUp(event) {
      if (!state.dragging || (event && event.pointerId !== state.pointerId)) return;
      state.dragging = false;
      state.pointerId = null;
      track.classList.remove('is-dragging');
      track.removeEventListener('pointermove', onPointerMove);
      track.removeEventListener('pointerup', onPointerUp);
      track.removeEventListener('pointercancel', onPointerUp);

      if (!state.moved) return;

      var moved = displayedOffset(track) - state.startOffset;
      var startIndex = Math.round(state.startOffset / slideStep(track));
      var flick = Math.abs(state.velocity) > 0.35;

      if (flick || Math.abs(moved) > slideStep(track) * 0.18) {
        goTo(track, startIndex + (moved > 0 ? 1 : -1));
      } else {
        goTo(track, startIndex);
      }
    }

    track.addEventListener('pointerdown', onPointerDown);

    track.addEventListener(
      'click',
      function (event) {
        if (!state.moved) return;
        event.preventDefault();
        event.stopPropagation();
        state.moved = false;
      },
      true
    );

    track.addEventListener(
      'wheel',
      function (event) {
        if (maxOffset(track) <= 0) return;
        var delta = Math.abs(event.deltaY) > Math.abs(event.deltaX) ? event.deltaY : event.deltaX;
        if (Math.abs(delta) < 8) return;
        event.preventDefault();
        if (state.wheelLock) return;
        state.wheelLock = true;
        goTo(track, currentIndex(track) + (delta > 0 ? 1 : -1));
        window.setTimeout(function () {
          state.wheelLock = false;
        }, 480);
      },
      { passive: false }
    );

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        goTo(track, currentIndex(track));
      }, 120);
    });
  }

  function ensureInner(track) {
    var inner = getInner(track);
    if (inner) return inner;
    inner = document.createElement('div');
    inner.className = INNER_CLASS;
    while (track.firstChild) {
      inner.appendChild(track.firstChild);
    }
    track.appendChild(inner);
    return inner;
  }

  function wrapProducts(shadow) {
    var root = shadow.querySelector('.all-widgets') || shadow.querySelector('#cartDrawer-slot-5');
    if (!root) return;

    var track = root.querySelector(':scope > .' + TRACK_CLASS);
    var loose = [];
    for (var i = 0; i < root.children.length; i++) {
      if (isProductCard(root.children[i])) loose.push(root.children[i]);
    }

    if (!track && !loose.length) return;

    if (!track) {
      track = document.createElement('div');
      track.className = TRACK_CLASS;
      loose[0].parentNode.insertBefore(track, loose[0]);
    }

    var inner = ensureInner(track);

    for (var j = 0; j < loose.length; j++) {
      inner.appendChild(loose[j]);
    }

    bindSlider(track);
    if (typeof track._calistaRcOffset === 'number') {
      setOffset(track, track._calistaRcOffset, false);
    }
  }

  function enhanceShadow(shadow) {
    if (!shadow) return;
    injectStyle(shadow);
    wrapProducts(shadow);
    if (shadow._calistaRcObserved) return;
    shadow._calistaRcObserved = true;
    var timer;
    var observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        injectStyle(shadow);
        wrapProducts(shadow);
      }, 120);
    });
    observer.observe(shadow, { childList: true, subtree: true });
  }

  function waitForShadow(host) {
    if (host._calistaRcWatching) return;
    host._calistaRcWatching = true;

    repositionHost(host);

    if (host.shadowRoot) {
      enhanceShadow(host.shadowRoot);
    }

    var tries = 0;
    var poll = setInterval(function () {
      tries += 1;
      if (host.shadowRoot) {
        clearInterval(poll);
        enhanceShadow(host.shadowRoot);
      } else if (tries > 100) {
        clearInterval(poll);
      }
    }, 100);
  }

  function scan() {
    var hosts = document.querySelectorAll(HOST_SELECTOR);
    for (var i = 0; i < hosts.length; i++) {
      repositionHost(hosts[i]);
      waitForShadow(hosts[i]);
    }
  }

  scan();
  document.addEventListener('DOMContentLoaded', scan);

  var scanTimer;
  function scheduleScan() {
    clearTimeout(scanTimer);
    scanTimer = setTimeout(scan, 100);
  }

  var pageObserver = new MutationObserver(scheduleScan);
  pageObserver.observe(document.body, { childList: true, subtree: true });
})();
